export const fmt = (n: number) => n.toLocaleString('en-CA');

export const pct = (part: number, whole: number, digits = 1) =>
  whole > 0 ? `${((part / whole) * 100).toFixed(digits)}%` : '—';

export const DASH = '—';

export const orDash = (v: string | number | null | undefined) =>
  v === null || v === undefined || v === '' ? DASH : String(v);

export function dateShort(value: string | Date | null | undefined) {
  if (!value) return DASH;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return DASH;
  return d.toLocaleDateString('en-CA', { day: '2-digit', month: 'short', year: 'numeric' });
}

export function dateLong(value: string | Date | null | undefined) {
  if (!value) return DASH;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return DASH;
  return d.toLocaleDateString('en-CA', { day: 'numeric', month: 'long', year: 'numeric' });
}

export function utcStamp(value: string | Date | null | undefined) {
  if (!value) return DASH;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return DASH;
  const date = d.toLocaleDateString('en-CA', { day: '2-digit', month: 'short', timeZone: 'UTC' });
  const time = d.toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    timeZone: 'UTC',
  });
  return `${date} ${time}`;
}

export function tenure(since: string | Date | null | undefined) {
  if (!since) return DASH;
  const start = new Date(since);
  if (Number.isNaN(start.getTime())) return DASH;
  const months = Math.max(0, Math.round((Date.now() - start.getTime()) / (1000 * 60 * 60 * 24 * 30.44)));
  if (months < 12) return `${months} mo`;
  const years = months / 12;
  return `${years.toFixed(1)}y`;
}

export function duration(ms: number | null | undefined) {
  if (ms === null || ms === undefined) return DASH;
  if (ms < 1000) return '<1s';
  const total = Math.round(ms / 1000);
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${m}m ${String(s).padStart(2, '0')}s`;
}

export function relative(value: string | Date | null | undefined) {
  if (!value) return DASH;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return DASH;
  const mins = Math.round((Date.now() - d.getTime()) / 60000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins} min ago`;
  const hours = Math.round(mins / 60);
  if (hours < 24) return `${hours} hr ago`;
  const days = Math.round(hours / 24);
  if (days <= 30) return `${days} d ago`;
  return dateShort(d);
}
